import { render, staticRenderFns } from "./NuevoProrroga.vue?vue&type=template&id=530debc9&scoped=true"
import script from "./NuevoProrroga.vue?vue&type=script&lang=js"
export * from "./NuevoProrroga.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./NuevoProrroga.vue?vue&type=style&index=2&id=530debc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530debc9",
  null
  
)

export default component.exports